export default {
  toasts: {
    success: 'Lahjakortti lunastettiin onnistuneesti.',
    error: 'Lahjakortin lunastaminen epäonnistui.',
  },
  title: 'Lunasta lahjakortti',
  subtitle: 'Anna lahjakortin koodi ja lunastettava summa asiakkaan laskusta.',
  form: {
    amount: {
      label: 'Lunastettava summa',
    },
    code: {
      label: 'Lahjakortin koodi',
    },
  },
  buttons: {
    redeem: 'Lunasta',
    cancel: 'Peruuta',
  },
};
